import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-custom-sms-popup',
  templateUrl: './custom-sms-popup.component.html',
  styleUrls: ['./custom-sms-popup.component.css']
})
export class CustomSmsPopupComponent {

  smsCount: number = 0;
  smsDates: (Date | null)[] = [];
  isViewMode: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CustomSmsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.isViewMode) {
      this.isViewMode = data.isViewMode;
    }
    if (data && data.dates && Array.isArray(data.dates)) {
      this.smsDates = [...data.dates];
      this.smsCount = this.smsDates.length;
    }
  }
  

  onCountChange() {
    if (this.smsCount < 0) {
      this.smsCount = 0;
    }

    const currentLen = this.smsDates.length;
    if (this.smsCount > currentLen) {
      const diff = this.smsCount - currentLen;
      for (let i = 0; i < diff; i++) {
        this.smsDates.push(null);
      }
    } else {
      this.smsDates = this.smsDates.slice(0, this.smsCount);
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  isValid(): boolean {
    return this.smsCount > 0 && this.smsDates.length === this.smsCount && this.smsDates.every(date => !!date);
  }

  onSave() {
    this.dialogRef.close(this.smsDates);
  }

  onCancel() {
    this.dialogRef.close();
  }

}
